import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-project-health',
  templateUrl: './project-health.component.html',
  styleUrls: ['./project-health.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectHealthComponent implements OnInit {

  mockIndicators: any[] = [
    {
      title: 'Clarity',
      score: 21,
      trend: 'down',
      icon: 'clarity',
      gradientColor: 'linear-gradient(#E83032, #BE1A1C)',
    },
    {
      title: 'Efficiency ',
      score: 71,
      trend: 'up',
      icon: 'efficiency',
      gradientColor: 'linear-gradient(#FFC828, #E6AB00)',
    },
    {
      title: 'Collaboration',
      score: 88,
      trend: 'up',
      icon: 'collaboration',
      gradientColor: 'linear-gradient(#00BD82, #029B6B)',
    },
    {
      title: 'Workload',
      score: 60,
      trend: 'down',
      icon: 'workload',
      gradientColor: 'linear-gradient(#FE9001, #DC7E04)',
    },
    {
      title: 'Engagement',
      score: 80,
      trend: 'down',
      icon: 'engagement',
      gradientColor: 'linear-gradient(#00BD82, #029B6B)',
    },
    {
      title: 'Quality',
      score: 92,
      trend: 'up',
      icon: 'quality',
      gradientColor: 'linear-gradient(#00BD82, #029B6B)',
    },
  ];

  constructor() { }

  ngOnInit(): void {

  }

}
